"use client";

import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqData = [{
  id: 1,
  question: "What HVAC services does K&M Mechanical services offer?",
  answer: "K&M Mechanical services provides comprehensive residential and commercial HVAC solutions including system design, installation, maintenance, and emergency repairs. We specialize in heating, ventilation, and air conditioning to ensure year-round comfort."
}, {
  id: 2,
  question: "Do you offer emergency HVAC repair services?",
  answer: "Yes, we provide emergency HVAC repair services to address urgent heating and cooling issues. Our experienced technicians are available to restore comfort quickly and efficiently."
}, {
  id: 3,
  question: "How can I improve my indoor air quality?",
  answer: "We offer tailored solutions to enhance indoor air quality, including air purifier installations, replacement filters, and advanced diagnostics. Our team assesses your specific needs to recommend energy-efficient options."
}, {
  id: 4,
  question: "What areas does K&M Mechanical services serve?",
  answer: "K&M Mechanical services proudly serves Pittsburgh, PA and surrounding areas. We are dedicated to providing dependable climate control solutions for Pennsylvania homeowners and businesses."
}, {
  id: 5,
  question: "How often should I schedule HVAC maintenance?",
  answer: "We recommend scheduling HVAC maintenance at least once a year to ensure optimal performance, energy efficiency, and to prevent unexpected breakdowns. Regular maintenance extends the lifespan of your system."
}, {
  id: 6,
  question: "Are your HVAC systems energy-efficient?",
  answer: "Absolutely. We prioritize energy efficiency in all our installations and recommendations. Our advanced diagnostics and quality materials help reduce energy consumption while maintaining reliable performance."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className={`py-16 px-4 md:px-8 lg:px-16 bg-background transition-opacity duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-2 text-center">
          Frequently Asked Questions
        </h2>
        <p className="text-base md:text-lg text-muted-foreground text-center mb-12">
          Find answers to common questions about our HVAC services and solutions.
        </p>

        <Accordion type="single" collapsible className="space-y-4">
          {faqData.map(faq => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={faq.id} className="border border-border rounded-lg px-6 shadow-soft hover:shadow-medium transition-shadow duration-[150ms] ease-out">
              <AccordionTrigger className="text-base md:text-lg font-semibold text-foreground hover:text-primary transition-colors duration-[150ms]">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}